"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ShortUrls", {
  enumerable: true,
  get: function get() {
    return _ShortUrls["default"];
  }
});
var _ShortUrls = _interopRequireDefault(require("./ShortUrls"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }